import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="submission-evidence"
export default class extends Controller {
  static targets = ["url", "noUrl", "noUrlToggle", "noUrlNotice", "fallback", "blockedNotice"]

  connect() {
    this.refresh()
  }

  refresh() {
    const noUsableUrl = this.noUrlTarget.checked
    const blockedUrl = this.blockedUrl()
    const needsFallbackEvidence = noUsableUrl || blockedUrl

    // The input stays enabled so a link the user considers unusable (a marketplace
    // listing, a social post) still reaches research as a hint. It just stops being required.
    this.urlTarget.required = !noUsableUrl
    this.noUrlTarget.setAttribute("aria-expanded", needsFallbackEvidence.toString())
    this.fallbackTarget.hidden = !needsFallbackEvidence
    this.blockedNoticeTarget.hidden = !blockedUrl
    this.noUrlToggleTargets.forEach(toggle => { toggle.hidden = noUsableUrl })
    this.noUrlNoticeTargets.forEach(notice => { notice.hidden = !noUsableUrl })
  }

  blockedUrl() {
    try {
      const host = new URL(this.urlTarget.value).hostname.toLowerCase().replace(/^www\./, "")

      return host === "shp.ee" ||
        host.endsWith(".shp.ee") ||
        host === "shopee.com" ||
        host.startsWith("shopee.") ||
        host.includes(".shopee.")
    } catch (_error) {
      return false
    }
  }
}
